import {IRegionAncestor} from "../../list/actions/offer_list_selected_data_actions";
import {OfferType} from "../../types/OfferType";

export type ListingNameType = "tanie" | "luksusowe" | "gotowe";

interface IBreadcrumbs {
    region_type_voivodeship: IRegionAncestor | null;
    region_type_city: IRegionAncestor | null;
    region_type_county: IRegionAncestor | null;
    region_type_district: IRegionAncestor | null;
    region_type_town: IRegionAncestor | null;
}

const getListingNameType = (type: OfferType) => {
    if (!type) {
        return "mieszkania-i-domy";
    }

    switch (type) {
        case OfferType.FLAT:
            return "mieszkania";
        case OfferType.HOUSE:
            return "domy";
        case OfferType.COMMERCIAL:
            return "lokale-uzytkowe";
    }
};

const getListingLocation = (breadcrumbs: IBreadcrumbs) => {
    const {region_type_voivodeship, region_type_city, region_type_county, region_type_district, region_type_town} = breadcrumbs;

    if (region_type_district?.slug) {
        //User selected city district just like Wola, Ochota etc.
        return `-${region_type_district.slug}`;
    } else if (region_type_town?.slug) {
        //User selected town
        return `-${region_type_town.slug}`;
    } else if (region_type_city?.slug) {
        return `-${region_type_city.slug}`;
    } else if (region_type_county?.slug) {
        //User selected county just like sochaczewski, legionowski
        return `-${region_type_county?.slug}`;
    } else if (region_type_voivodeship?.slug) {
        return `-${region_type_voivodeship.slug}`;
    } else {
        //No region selected
        return "";
    }
};

export const buildSpecialListingLink = (listingName: ListingNameType, type: OfferType, breadcrumbs: IBreadcrumbs) => {
    return `${listingName}-${getListingNameType(type)}${getListingLocation(breadcrumbs)}`;
};
import {IRegionAncestor} from "../../list/actions/offer_list_selected_data_actions";
import {OfferType} from "../../types/OfferType";

export type ListingNameType = "tanie" | "luksusowe" | "gotowe";

interface IBreadcrumbs {
    region_type_voivodeship: IRegionAncestor | null;
    region_type_city: IRegionAncestor | null;
    region_type_county: IRegionAncestor | null;
    region_type_district: IRegionAncestor | null;
    region_type_town: IRegionAncestor | null;
}

const getListingNameType = (type: OfferType) => {
    if (!type) {
        return "mieszkania-i-domy";
    }

    switch (type) {
        case OfferType.FLAT:
            return "mieszkania";
        case OfferType.HOUSE:
            return "domy";
        case OfferType.COMMERCIAL:
            return "lokale-uzytkowe";
    }
};

const getListingLocation = (breadcrumbs: IBreadcrumbs) => {
    const {region_type_voivodeship, region_type_city, region_type_county, region_type_district, region_type_town} = breadcrumbs;

    if (region_type_district?.slug) {
        //User selected city district just like Wola, Ochota etc.
        return `-${region_type_district.slug}`;
    } else if (region_type_town?.slug) {
        //User selected town
        return `-${region_type_town.slug}`;
    } else if (region_type_city?.slug) {
        return `-${region_type_city.slug}`;
    } else if (region_type_county?.slug) {
        //User selected county just like sochaczewski, legionowski
        return `-${region_type_county?.slug}`;
    } else if (region_type_voivodeship?.slug) {
        return `-${region_type_voivodeship.slug}`;
    } else {
        //No region selected
        return "";
    }
};

export const buildSpecialListingLink = (listingName: ListingNameType, type: OfferType, breadcrumbs: IBreadcrumbs) => {
    return `${listingName}-${getListingNameType(type)}${getListingLocation(breadcrumbs)}`;
};
